"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const GetNextBestOfferQueryRequestBase_1 = require("../GetNextBestOfferQueryRequestBase");
class GetNextBestOfferQueryRequestV3 extends GetNextBestOfferQueryRequestBase_1.GetNextBestOfferQueryRequestBase {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)({ maxDecimalPlaces: 0 }),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(5),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_transformer_1.Expose)({ name: 'max_offers' }),
    (0, base_models_1.Docs)({ example: 2, description: 'The max number of offers that should be returned.' }),
    tslib_1.__metadata("design:type", Number)
], GetNextBestOfferQueryRequestV3.prototype, "maxOffers", void 0);
exports.default = GetNextBestOfferQueryRequestV3;
